import { defineMessages } from 'react-intl';

export default defineMessages({
  gradeData: 'Dane klasy',
  insertGradeName: 'Wpisz nazwę klasy',
  respondersCount: 'Ilość badanych',
  generateLinks: 'Wygeneruj link',
  mustBeInteger: 'Wartość musi być liczbą całkowitą',
});
